import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=17192532"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\三菱\\product_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17192532')) {
      api.createRecord('17192532', component.options)
    } else {
      api.reload('17192532', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=17192532", function () {
      api.rerender('17192532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fwpt/profile/components/ResetPassword.vue"
export default component.exports